import React, { useEffect, useState } from "react";
import "./BlockKeywordScreen.css";
import { deleteBlockKeyword, getBlockKeyword } from "../../../config/LiveApi";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import AddNewKeyword from "../block-keyword/AddNewKeyword";
import { MdDelete } from "react-icons/md";
import ConfirmationModal from "../../../components/common/ConfirmModal";
import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";
import Spinner from "../../Spin/Spinner";

const BlockKeywordPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [keywordToDelete, setKeywordToDelete] = useState(null);

  const fetchBlockKeywordData = async (currentPage, searchTerm) => {
    try {
      setLoading(true);
      const response = await getBlockKeyword(currentPage, searchTerm);
      setStatusData(response);
    } catch (error) {
      toast.error("Unable to fetch status.");
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (id) => {
    setKeywordToDelete(id);
    setShowConfirmModal(true);
  };

  const handleModalResolve = async (confirmed) => {
    setShowConfirmModal(false);
    if (confirmed && keywordToDelete) {
      try {
        await deleteBlockKeyword(keywordToDelete);
        toast.success("Keyword deleted successfully");
        fetchBlockKeywordData(currentPage, searchTerm);
      } catch (err) {
        toast.error("Failed to delete keyword");
      }
    }
    setKeywordToDelete(null);
  };

  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchBlockKeywordData(1, searchTerm);
      }, 2000);

      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchBlockKeywordData(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  const columns = [
  {
    key: "keyword",
    header: "Keyword",
    render: (row) => row.keyword || "-",
  },
  {
    key: "createdAt",
    header: "Created At",
    render: (row) => <DateCell date={row.createdAt} />,
  },
  {
    key: "updatedAt",
    header: "Updated At",
    render: (row) => <DateCell date={row.updatedAt} />,
  },
  {
    key: "action",
    header: "Remove",
    render: (row) => (
      <MdDelete
        size={22}
        style={{ cursor: "pointer" }}
        onClick={() => confirmDelete(row._id)}
      />
    ),
  },
];

  return (
    <div className="block-key-table-container">
      <div className="block-key-add">
        <div className="block-key-heading">
          <h2 className="block-key-table-title">Block Keyword</h2>
          <input
            className="block-key-input-field-container"
            type="text"
            placeholder="enter keyword"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div>
          <button
            className="keyword-add-button"
            onClick={() => setIsAddModalOpen(true)}
          >
            Add +
          </button>
        </div>
      </div>

      <div>
        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={statusData}
            emptyMessage="No data found."
          />
        )}
      </div>

      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {isAddModalOpen && (
        <AddNewKeyword onClose={() => setIsAddModalOpen(false)} />
      )}

      {showConfirmModal && <ConfirmationModal onResolve={handleModalResolve} />}
    </div>
  );
};

export default BlockKeywordPage;
